import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";
import { API_PATH } from "../../utils/apis";

const initialState = {
  isLoading: false,
  isSummaryLoading: false,
  error: false,
  search: "",
  page: 0,
  perPage: 10,
  total: 0,
  refers: [],
  summary: null,
  sortBy: null,
  filters: {
    method: "",
  },
};

const slice = createSlice({
  name: "refer",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    startSummaryLoading(state) {
      state.isSummaryLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.isSummaryLoading = false;
      state.error = action.payload;
    },
    getSuccess(state, action) {
      state.isLoading = false;
      state.refers = action.payload.data;
      state.total = parseInt(action.payload.total || 0, 10);
    },
    getSummarySuccess(state, action) {
      state.isSummaryLoading = false;
      state.summary = action.payload;
    },
    //  SORT & FILTER POSTS
    sortBy(state, action) {
      state.sortBy = action.payload;
    },
    filter(state, action) {
      state.filters.method = action.payload.method;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filter, sortBy } = slice.actions;

export function getReferralSummary() {
  return async (dispatch) => {
    dispatch(slice.actions.startSummaryLoading());
    try {
      const response = await axios.get(API_PATH.getReferralSummary);
      const { status, data } = response.data;
      if (status === "success" || data) {
        dispatch(slice.actions.getSummarySuccess(data || response.data));
      } else {
        dispatch(slice.actions.getSummarySuccess(null));
      }
    } catch (error) {
      // Gracefully handle if summary endpoint is loading or returns empty
      dispatch(slice.actions.getSummarySuccess(null));
    }
  };
}

export function getReferrals() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(API_PATH.getReferrers);
      const { status, data, total } = response.data;
      if (status === "success") {
        dispatch(slice.actions.getSuccess({ data: data || [], total: total || (data ? data.length : 0) }));
      } else {
        dispatch(
          slice.actions.hasError(
            new Error(
              "We cannot fetch your referrals at the moment! Please check back later."
            )
          )
        );
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

